<script>
  export let product
  export let value
  export let selectedProduct
  export let selectedOption
  function toggleButton(option_type, option_value) {
    if (option_value == option_type) {
      selectedOption = null
    } else {
      selectedOption = option_value
    }
  }
</script>

<li
  class="option"
  productSelected={product == selectedProduct}
  selected={product == selectedProduct && value == selectedOption}
>
  <div
    class="wrapped"
    on:click={() => toggleButton(selectedOption, value)}
    on:keypress={() => toggleButton(selectedOption, value)}
    role="button"
    tabindex="0"
  >
    {#if value.image}
      <img
        src={value.image}
        loading="lazy"
        alt={value.presentation.replace(/<\/?[^>]+(>|$)/g, "")}
      />
    {/if}
  </div>
  <span class="title">{@html value.presentation}</span>
</li>
